import * as React from 'react';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { VERIFICATION_ORGANIZATION_ID } from '@pec/aion-ui-core/constants/organizations';
import { usePermission } from '../hooks/usePermission';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';

export const ExternalVerificationAlert: React.FC = () => {
  const { t } = useTranslation();
  const { allUserOrganizations } = useSelector((state: CommonRootState) => state.userOrganizations);
  const { organization } = useSelector((state: CommonRootState) => state.organization);
  const { organizationInfo } = useSelector((state: CommonRootState) => state.organizationInfo);
  const { hasGlobalPermission, hasOrganizationOnlyPermission } = usePermission();
  const showMessage =
    organizationInfo?.isChild &&
    organization?.features.includes(OrganizationFeature.VerificationStatusExternalSource) &&
    allUserOrganizations?.some(organization => organization.id === VERIFICATION_ORGANIZATION_ID) &&
    (hasGlobalPermission(ActivityAction.Manage, ActivityResourceName.ContractorsQuestionnaire) ||
      hasOrganizationOnlyPermission(ActivityAction.Manage, ActivityResourceName.ContractorsQuestionnaire));

  if (!showMessage) return null;

  return (
    <Alert severity="info">
      {t(
        'externalVerificationAlert.title',
        'Organisation feature "control verification status from external source" is active on this organisation.'
      )}
    </Alert>
  );
};
